import { useState } from 'react';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import A from './ActionCreators';

import Tooltip from '@material-ui/core/Tooltip';
import { SCREENSHOT_IGNORE } from './UIConstants';
import AddRowCircle from './AddRowCircle';

export default function RowAdder({rowIndex,side,alwaysVisible,columnIndex,level,figurePanelId,tooltip,tooltipPlacement,
  pointerEvents,
}){

  if(!figurePanelId){
    throw Error("RowAdder: figurePanelId cannot be undefined.");
  }

  let [visible,setVisible] = useState(false);
  //visible = true;

  const dispatch = useDispatch();

  let xTranslateSign = (side==='right'?'-':'');
  let yTranslate = side!==undefined?'-50%':(level==='top'?'-10%':'50%');
  let xTranslate = side!==undefined?'-50%':(level==='top'?'-12%':'50%');

  const onClick = e=>{
    e.stopPropagation();
    if( !isNaN(rowIndex) ){
      dispatch(A.insertRow({figurePanelId,rowIndex}))
    }else if( !isNaN(columnIndex) ){
      dispatch(A.insertColumn({figurePanelId,columnIndex}))
    }
  }



  let width = 30;
  let height = 30;
  

  if(side){
    width = 16;
    height = 18;
  }

  if( side === 'right' ){
    xTranslate = '0%';
    yTranslate = '-50%';
  }else if( side === 'left' ){
    xTranslate = '-100%'
  }

  return (

    <div 
      action={"add-row-"+rowIndex+"-"+side}
      class={"" + SCREENSHOT_IGNORE}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      style={{
        top:0,
        right:(side==='right'? 0 :undefined),
        left:(side==='left'? 0 :undefined),
        width,
        height,
        pointerEvents,
        transform:`translate(${xTranslateSign}${xTranslate},${yTranslate})`,
        position:'relative',
      }}>
      

      {(alwaysVisible||visible) && <div style={{
      position:'absolute',top:'50%',left:'50%',
      width:5,
      height:5,
      borderRadius:5,
      background:'#ddd',

      transform:'translate(-50%,-50%)'
    }}/>}
      {visible && <AddRowCircle {...{rowIndex,side,alwaysVisible,onClick}}/>}
    </div>

  )
}
